import { render } from "./Chapter1.vue?vue&type=template&id=0fea49fe&scoped=true"
import script from "./Chapter1.vue?vue&type=script&lang=js"
export * from "./Chapter1.vue?vue&type=script&lang=js"

import "./Chapter1.vue?vue&type=style&index=0&id=0fea49fe&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fea49fe"]])

export default __exports__